!function () {
    if (window.golfbox === undefined) {
        window.golfbox = window.gb = {};
    }

    let _ = {};
    window.gb.ui = _;

    _.sync = function (selector, options) {
        let _options = {
            height: false,
            width: false
        };

        if (options) {
            $.extend(_options, options);
        }

        let elms = $(selector);

        let func = function () {
            if (_options.width) {
                let maxWidth = elms.toArray().max(function (e) { return $(e).outerWidth(false); });
                elms.css('width', maxWidth);
            }

            if (_options.height) {
                let maxHeight = elms.toArray().max(function (e) { return $(e).outerHeight(false); });
                elms.css('height', maxHeight);
            }
        };

        elms.on('resize', func);
        func();
    };

    // https://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport/7557433#7557433
    _.position = (function () {
        var $header;
        var $nav;
        return function (element) {
            let result = {
                visible: function () {
                    return this.inside.top && this.inside.right && this.inside.bottom && this.inside.left;
                },
                inside: {
                    top: false,
                    right: false,
                    bottom: false,
                    left: false
                }
            };

            //special bonus for those using jQuery
            if (typeof jQuery === "function" && element instanceof jQuery) {
                element = element[0];
            }

            let rect = element.getBoundingClientRect();

            let _head = $header || ($header = $('header'));
            let _nav =  $nav    || ($nav = $('nav'));

            result.inside.top = rect.top - _head.outerHeight() >= 0;
            result.inside.left = rect.left - _nav.outerWidth() >= 0;
            result.inside.bottom = rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);
            result.inside.right = rect.right <= (window.innerWidth || document.documentElement.clientWidth);

            return result;
        }
    })();

    _.spinner = {
        show: (element) => {
            element.removeClass('loaded hidden');
        },
        hide: (element) => {
            element.addClass('loaded');

            setTimeout(() => {
                element.addClass('hidden');
            }, 200);
        },
        create: () => {
            return $('<div class="loadingSpinner hidden"><div class="spinner"><div class="spinner-rect"></div><div class="spinner-rect"></div><div class="spinner-rect"></div><div class="spinner-rect"></div><div class="spinner-rect"></div></div ></div >');
        }
    };

    /* https://css-tricks.com/using-css-transitions-auto-dimensions/ */
    _.collapse = (element) => {
        // get the height of the element's inner content, regardless of its actual size
        var sectionHeight = element.scrollHeight;

        // temporarily disable all css transitions
        var elementTransition = element.style.transition;
        element.style.transition = '';

        // on the next frame (as soon as the previous style change has taken effect),
        // explicitly set the element's height to its current pixel height, so we
        // aren't transitioning out of 'auto'
        requestAnimationFrame(function () {
            element.style.height = sectionHeight + 'px';
            element.style.transition = elementTransition;

            // on the next frame (as soon as the previous style change has taken effect),
            // have the element transition to height: 0
            requestAnimationFrame(function () {
                element.style.height = 0 + 'px';
            });
        });

        // mark the section as "currently collapsed"
        $(element).toggleClass('collapsed expanded');
    };

    _.expand = (element) => {
        // get the height of the element's inner content, regardless of its actual size
        var sectionHeight = element.scrollHeight;

        // have the element transition to the height of its inner content
        element.style.height = sectionHeight + 'px';

        // when the next css transition finishes (which should be the one we just triggered)
        element.addEventListener('transitionend', function (e) {
            // remove this event listener so it only gets triggered once
            element.removeEventListener('transitionend', arguments.callee);

            // remove "height" from the element's inline styles, so it can return to its initial value
            element.style.height = null;
        });

        // mark the section as "currently not collapsed"
        $(element).toggleClass('collapsed expanded');
    };
}();